import type { Map2 } from './map-2';

import { Environment } from '../../../environments/environment';

// Reflects filter-driven position changes (restored from the URL or a saved search) back onto the map.
export function ApplyExtentFilter(this: Map2): void {
  if (
    !this.filteringService.lat() ||
    !this.filteringService.lng() ||
    !this.filteringService.lvl()
  ) {
    return;
  }
  if (
    this.filteringService.lat() === Environment.mapCenter[1] &&
    this.filteringService.lng() === Environment.mapCenter[0] &&
    this.filteringService.lvl() === Environment.mapZoom
  ) {
    return;
  }

  if (
    this.center()[0] !== this.filteringService.lng() ||
    this.center()[1] !== this.filteringService.lat()
  ) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- We check for null above, so this should be safe.
    this.center.set([this.filteringService.lng()!, this.filteringService.lat()!]);
  }

  if (this.zoom() !== this.filteringService.lvl() && this.filteringService.lvl() !== -1) {
    this.zoom.set(this.filteringService.lvl());
  }
}
